import { render, staticRenderFns } from "./CommitmentScenario.vue?vue&type=template&id=3a580b16"
import script from "./CommitmentScenario.vue?vue&type=script&lang=js"
export * from "./CommitmentScenario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports